import { render, staticRenderFns } from "./teacherSessionCostList.vue?vue&type=template&id=210635d0&scoped=true&"
import script from "./teacherSessionCostList.vue?vue&type=script&lang=js&"
export * from "./teacherSessionCostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210635d0",
  null
  
)

export default component.exports